// Spreadsheet → CSV bridge for the bulk importer. When a user uploads an
// .xlsx/.xls instead of a .csv, we convert the first worksheet to CSV text in
// the browser and feed it into the SAME (already-tested) CSV pipeline
// (parseImportCsv) — so there is one parser, and xlsx is just "CSV we generated
// from the sheet". SheetJS is loaded with a dynamic import() so it only enters
// the bundle as a lazy chunk when someone actually drops a spreadsheet.

// Convert an .xlsx/.xls ArrayBuffer to CSV text (first non-empty sheet).
// Returns "" when the workbook has no sheets. Cell values are coerced to their
// displayed text; blank rows are dropped (parseImportCsv drops them too).
export async function xlsxToCsv(arrayBuffer) {
  const mod = await import("xlsx");
  const XLSX = mod.read ? mod : mod.default; // CJS/ESM interop under Vite
  const wb = XLSX.read(arrayBuffer, { type: "array" });
  const sheetName = wb.SheetNames[0];
  if (!sheetName) return "";
  return XLSX.utils.sheet_to_csv(wb.Sheets[sheetName], { blankrows: false });
}

// True for filenames the importer can read directly as a spreadsheet.
export function isSpreadsheet(name) {
  return /\.(xlsx|xls)$/i.test(name || "");
}
